export default __webpack_public_path__ + "static/media/strataprimelogo.98c814ac.png";